import _classCallCheck from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { MessageApi, Common } from "../api";
import "../common";
import { BaseResource } from "@kgsport-cms/common";
export var MessageService = /*#__PURE__*/function (_BaseResource) {
  _inherits(MessageService, _BaseResource);
  var _super = _createSuper(MessageService);
  function MessageService() {
    _classCallCheck(this, MessageService);
    return _super.apply(this, arguments);
  }
  _createClass(MessageService, [{
    key: "list",
    value: function list(params) {
      return this.requester.get(MessageApi.list, {
        params
      });
    }
  }, {
    key: "count",
    value: function count() {
      return this.requester.get(MessageApi.getCount);
    }
  }, {
    key: "remove",
    value: function remove(_ref) {
      var idList = _ref.idList;
      return this.requester.post(MessageApi.remove, {
        idList
      });
    }
  }, {
    key: "read",
    value: function read(_ref2) {
      var idList = _ref2.idList;
      return this.requester.post(MessageApi.read, {
        idList
      });
    }
  }, {
    key: "allRead",
    value: function allRead() {
      return this.requester.post(MessageApi.readAll);
    }
  }, {
    key: "detail",
    value: function detail(_ref3) {
      var id = _ref3.id;
      return this.requester.get(MessageApi.info + id);
    }
  }, {
    key: "sysDetail",
    value: function sysDetail(_ref4) {
      var id = _ref4.id;
      return this.requester.get(Common.detailInfo + id);
    }
  }, {
    key: "propMessage",
    value: function propMessage(params) {
      return this.requester.get(MessageApi.propMessage, {
        params
      });
    }
  }]);
  return MessageService;
}(BaseResource);